// Bilingual content for Pizza On The Road
export const translations = {
  it: {
    nav: {
      home: "Home",
      menu: "Menu",
      hours: "Orari",
      contact: "Contatti",
      address: "Indirizzo",
      gallery: "Opere d'Arte",
      allergens: "Allergeni",
      cta: "Scopri il menu",
    },
    hero: {
      eyebrow: "Porto San Giorgio · Marche",
      title: "Croccante fuori,",
      titleAlt: "irresistibile dentro.",
      sub: "Forno vivo, ingredienti scelti, in viaggio fino a te.",
      cta: "Scopri il menu",
      ghost: "Chiamaci ora",
      where: "Dove ci trovi",
    },
    partner: {
      tgtgLabel: "Partner",
      tgtgText: "Disponibile su Too Good To Go",
      tgtgShort: "Too Good To Go",
    },
    whatsapp: {
      label: "Ordina su WhatsApp",
      short: "Ordina",
      tipTitle: "Come scrivere l'ordine",
      tips: [
        "Ordini accettati fino alle 18:30",
        "Indica il giorno e l'orario di ritiro",
        "Separa le pizze ROSSE dalle pizze BIANCHE",
        "Distingui quelle CON mozzarella da quelle SENZA",
      ],
      // Pre-filled message (structured so the customer follows the format)
      message:
        "Ciao Pizza On The Road! Vorrei ordinare 🍕\n\n📅 Giorno: \n🕐 Orario di ritiro: \n\n🔴 PIZZE ROSSE\n• Con mozzarella: \n• Senza mozzarella: \n\n⚪ PIZZE BIANCHE\n• Con mozzarella: \n• Senza mozzarella: \n\nGrazie!",
    },
    misc: {
      scroll: "scorri",
    },
    status: {
      openNow: "Aperto ora",
      closedNow: "Chiuso ora",
      closedToday: "Chiuso oggi",
      closedMonday: "Chiuso il lunedì",
      today: "Oggi",
      opens: "apre",
    },
    sections: {
      menu: "Il Menu",
      menuSub: "Sfoglia le categorie",
      hours: "Orari",
      contact: "Contatti",
      address: "Indirizzo",
      gallery: "Opere d'Arte",
      allergens: "Allergeni",
      allergensInline: "Alcuni prodotti possono contenere allergeni. Elenco completo nella sezione Allergeni in fondo alla pagina o su richiesta al personale.",
      allergensToggle: "Vedi elenco",
      allergensSub: "Informativa ai sensi del Reg. UE 1169/2011",
      allergensNote: "Per ulteriori informazioni o chiarimenti, si prega di chiedere al personale.",
    },
    hours: {
      weekdays: "Martedì – Domenica",
      weekdaysAugustLabel: "Lunedì – Domenica",
      weekdaysTime: "16:30 – 20:30",
      weekend: "Lunedì",
      weekendAugustLabel: "Lunedì · solo agosto",
      weekendTime: "Chiuso",
      augustBadge: "Ad agosto aperti tutti i giorni",
      augustNote: "Ad agosto aperti anche il lunedì",
    },
    contact: {
      phoneLabel: "Telefono",
      phone: "+39 333 141 7551",
      emailLabel: "Email",
      email: "pizza.ontheroad26@gmail.com",
      callCta: "Ordina ora",
    },
    address: {
      name: "Pizza On The Road",
      street: "Via Gaetano Properzi, 219B",
      city: "63822 Porto San Giorgio (FM)",
      region: "Marche, Italia",
      directions: "Indicazioni",
    },
    categories: {
      rosse: "Pizze Rosse",
      bianche: "Pizze Bianche",
      top: "Pizze Top",
    },
    footer: {
      tagline: "Impasto artigianale · Made in Marche",
      rights: "Tutti i diritti riservati",
    },
    items: {
      // ---- Pizze Rosse ----
      marinara: { n: "Marinara", d: "Pomodoro, origano, olio EVO" },
      marinaraFarcita: {
        n: "Marinara Farcita",
        d: "Pomodoro, aglio, origano, olive, capperi, acciughe, olio EVO",
      },
      mediterranea: {
        n: "Mediterranea",
        d: "Pomodoro, origano, peperoncino, capperi, mozzarella a crudo, pomodorini, aglio, rucola",
      },
      margherita: { n: "Margherita", d: "Pomodoro, fior di latte, basilico" },
      salamePiccante: {
        n: "Salame Piccante",
        d: "Pomodoro, mozzarella, salame piccante",
      },
      capricciosa: {
        n: "Capricciosa",
        d: "Pomodoro, mozzarella, prosciutto cotto, funghi, carciofi, olive",
      },
      salsicciaPatate: {
        n: "Salsiccia e Patate",
        d: "Pomodoro, mozzarella, salsiccia, patate",
      },
      mais: { n: "Mais", d: "Pomodoro, mozzarella, mais dolce" },
      wurstel: { n: "Wurstel", d: "Pomodoro, mozzarella, wurstel" },
      amatriciana: {
        n: "Amatriciana",
        d: "Pomodoro, guanciale, pecorino romano, cipolla, pepe nero",
      },
      funghi: { n: "Funghi", d: "Pomodoro, mozzarella, funghi champignon" },
      carciofi: { n: "Carciofi", d: "Pomodoro, mozzarella, carciofi" },
      patatePancetta: {
        n: "Patate e Pancetta",
        d: "Pomodoro, mozzarella, patate, pancetta",
      },
      quattroFormaggi: {
        n: "4 Formaggi",
        d: "Pomodoro, grana, mozzarella, provola, gorgonzola",
      },

      // ---- Pizze Bianche ----
      rosmarino: {
        n: "Rosmarino",
        d: "Olio EVO, rosmarino fresco, sale grosso",
      },
      farcitaSenzaMozzarella: {
        n: "Farcita senza Mozzarella",
        d: "Pomodoro, olive, capperi, acciughe, origano, olio EVO",
      },
      cipolla: { n: "Cipolla", d: "Cipolla bianca" },
      semi: {
        n: "Semi",
        d: "Olio EVO, semi misti (sesamo, papavero, lino, girasole), sale",
      },
      boscaiola: {
        n: "Boscaiola",
        d: "Mozzarella, funghi, prosciutto cotto",
      },
      speckProvola: {
        n: "Speck e Provola",
        d: "Mozzarella, speck dell'Alto Adige, provola affumicata",
      },
      salsicciaCipollaCaramellata: {
        n: "Salsiccia e Cipolla Caramellata",
        d: "Mozzarella, salsiccia, cipolla caramellata",
      },
      patatePancettaB: {
        n: "Patate e Pancetta",
        d: "Mozzarella, patate, pancetta, rosmarino",
      },
      patateSalsiccia: {
        n: "Patate e Salsiccia",
        d: "Mozzarella, patate, salsiccia",
      },
      patateProvola: {
        n: "Patate e Provola",
        d: "Mozzarella, patate, provola affumicata",
      },
      quattroFormaggiB: {
        n: "4 Formaggi",
        d: "Grana, mozzarella, provola, gorgonzola",
      },
      salsicciaFriarielli: {
        n: "Salsiccia e Friarielli",
        d: "Mozzarella, salsiccia napoletana, friarielli saltati",
      },
      friarielliPomodoriSecchi: {
        n: "Friarielli e Pomodori Secchi",
        d: "Mozzarella, friarielli, pomodori secchi sott'olio",
      },
      aliciFriarielli: {
        n: "Alici e Friarielli",
        d: "Mozzarella, alici del Cantabrico, friarielli",
      },
      norcina: {
        n: "Norcina",
        d: "Mozzarella, funghi trifolati, salsiccia, salsa tartufata",
      },
      carciofiCotto: {
        n: "Carciofi e Cotto",
        d: "Mozzarella, carciofi, prosciutto cotto",
      },
      tonnoPeperoni: {
        n: "Tonno e Peperoni",
        d: "Mozzarella, tonno, peperoni",
      },

      // ---- Pizze Top ----
      topMortadella: {
        n: "Mortadella",
        d: "Radicchio, rucola, mortadella, stracciatella, pesto di pistacchio",
      },
      topCiauscolo: {
        n: "Ciauscolo",
        d: "Radicchio, rucola, ciauscolo, bufala",
      },
      topSalmone: {
        n: "Salmone",
        d: "Radicchio, rucola, stracciatella, salmone, aceto balsamico",
      },
      topCrudo: {
        n: "Crudo",
        d: "Radicchio, rucola, bufala, prosciutto crudo",
      },
      topPomodorini: {
        n: "Pomodorini",
        d: "Pomodorini rossi e gialli, semi-dry, rucola, stracciatella, pesto di pistacchio",
      },
    },
  },
  en: {
    nav: {
      home: "Home",
      menu: "Menu",
      hours: "Hours",
      contact: "Contact",
      address: "Address",
      gallery: "Artworks",
      allergens: "Allergens",
      cta: "View menu",
    },
    hero: {
      eyebrow: "Porto San Giorgio · Italy",
      title: "Crunchy outside,",
      titleAlt: "irresistible inside.",
      sub: "Live oven, fine ingredients, on the way to you.",
      cta: "View the menu",
      ghost: "Call us",
      where: "Where to find us",
    },
    partner: {
      tgtgLabel: "Partner",
      tgtgText: "Available on Too Good To Go",
      tgtgShort: "Too Good To Go",
    },
    whatsapp: {
      label: "Order on WhatsApp",
      short: "Order",
      tipTitle: "How to write your order",
      tips: [
        "Orders accepted until 6:30pm",
        "State the pickup day and time",
        "Separate RED pizzas from WHITE pizzas",
        "Distinguish those WITH mozzarella from those WITHOUT",
      ],
      message:
        "Hi Pizza On The Road! I'd like to order 🍕\n\n📅 Day: \n🕐 Pickup time: \n\n🔴 RED PIZZAS\n• With mozzarella: \n• Without mozzarella: \n\n⚪ WHITE PIZZAS\n• With mozzarella: \n• Without mozzarella: \n\nThank you!",
    },
    misc: {
      scroll: "scroll",
    },
    status: {
      openNow: "Open now",
      closedNow: "Closed now",
      closedToday: "Closed today",
      closedMonday: "Closed on Mondays",
      today: "Today",
      opens: "opens",
    },
    sections: {
      menu: "The Menu",
      menuSub: "Browse the categories",
      hours: "Hours",
      contact: "Contact",
      address: "Address",
      gallery: "Artworks",
      allergens: "Allergens",
      allergensInline: "Some products may contain allergens. Full list in the Allergens section at the bottom of the page or on request to staff.",
      allergensToggle: "View list",
      allergensSub: "As per EU Reg. 1169/2011",
      allergensNote: "For further information or clarifications, please ask our staff.",
    },
    hours: {
      weekdays: "Tuesday – Sunday",
      weekdaysAugustLabel: "Monday – Sunday",
      weekdaysTime: "4:30pm – 8:30pm",
      weekend: "Monday",
      weekendAugustLabel: "Monday · August only",
      weekendTime: "Closed",
      augustBadge: "Open every day in August",
      augustNote: "In August also open on Mondays",
    },
    contact: {
      phoneLabel: "Phone",
      phone: "+39 333 141 7551",
      emailLabel: "Email",
      email: "pizza.ontheroad26@gmail.com",
      callCta: "Order now",
    },
    address: {
      name: "Pizza On The Road",
      street: "Via Gaetano Properzi, 219B",
      city: "63822 Porto San Giorgio (FM)",
      region: "Marche, Italy",
      directions: "Directions",
    },
    categories: {
      rosse: "Red Pizzas",
      bianche: "White Pizzas",
      top: "Top Pizzas",
    },
    footer: {
      tagline: "Hand-crafted dough · Made in Marche",
      rights: "All rights reserved",
    },
    items: {
      // ---- Red Pizzas ----
      marinara: { n: "Marinara", d: "Tomato, oregano, EVO oil" },
      marinaraFarcita: {
        n: "Stuffed Marinara",
        d: "Tomato, garlic, oregano, olives, capers, anchovies, EVO oil",
      },
      mediterranea: {
        n: "Mediterranean",
        d: "Tomato, oregano, chilli, capers, fresh mozzarella, cherry tomatoes, garlic, rocket",
      },
      margherita: { n: "Margherita", d: "Tomato, fior di latte, basil" },
      salamePiccante: {
        n: "Spicy Salami",
        d: "Tomato, mozzarella, spicy salami",
      },
      capricciosa: {
        n: "Capricciosa",
        d: "Tomato, mozzarella, ham, mushrooms, artichokes, olives",
      },
      salsicciaPatate: {
        n: "Sausage & Potatoes",
        d: "Tomato, mozzarella, sausage, potatoes",
      },
      mais: { n: "Corn", d: "Tomato, mozzarella, sweet corn" },
      wurstel: { n: "Hot Dog", d: "Tomato, mozzarella, hot dog sausage" },
      amatriciana: {
        n: "Amatriciana",
        d: "Tomato, guanciale, pecorino romano, onion, black pepper",
      },
      funghi: { n: "Mushrooms", d: "Tomato, mozzarella, champignon mushrooms" },
      carciofi: { n: "Artichokes", d: "Tomato, mozzarella, artichokes" },
      patatePancetta: {
        n: "Potatoes & Bacon",
        d: "Tomato, mozzarella, potatoes, pancetta",
      },
      quattroFormaggi: {
        n: "Four Cheese",
        d: "Tomato, grana, mozzarella, provola, gorgonzola",
      },

      // ---- White Pizzas ----
      rosmarino: {
        n: "Rosemary",
        d: "EVO oil, fresh rosemary, sea salt",
      },
      farcitaSenzaMozzarella: {
        n: "Stuffed (no Mozzarella)",
        d: "Tomato, olives, capers, anchovies, oregano, EVO oil",
      },
      cipolla: { n: "Onion", d: "White onion" },
      semi: {
        n: "Mixed Seeds",
        d: "EVO oil, mixed seeds (sesame, poppy, flax, sunflower), salt",
      },
      boscaiola: {
        n: "Boscaiola",
        d: "Mozzarella, mushrooms, cooked ham",
      },
      speckProvola: {
        n: "Speck & Provola",
        d: "Mozzarella, South Tyrolean speck, smoked provola",
      },
      salsicciaCipollaCaramellata: {
        n: "Sausage & Caramelised Onion",
        d: "Mozzarella, sausage, caramelised onion",
      },
      patatePancettaB: {
        n: "Potatoes & Bacon",
        d: "Mozzarella, potatoes, pancetta, rosemary",
      },
      patateSalsiccia: {
        n: "Potatoes & Sausage",
        d: "Mozzarella, potatoes, sausage",
      },
      patateProvola: {
        n: "Potatoes & Provola",
        d: "Mozzarella, potatoes, smoked provola",
      },
      quattroFormaggiB: {
        n: "Four Cheese",
        d: "Grana, mozzarella, provola, gorgonzola",
      },
      salsicciaFriarielli: {
        n: "Sausage & Friarielli",
        d: "Mozzarella, Neapolitan sausage, sautéed friarielli greens",
      },
      friarielliPomodoriSecchi: {
        n: "Friarielli & Sun-dried Tomatoes",
        d: "Mozzarella, friarielli greens, sun-dried tomatoes",
      },
      aliciFriarielli: {
        n: "Anchovies & Friarielli",
        d: "Mozzarella, Cantabrian anchovies, friarielli greens",
      },
      norcina: {
        n: "Norcina",
        d: "Mozzarella, sautéed mushrooms, sausage, truffle sauce",
      },
      carciofiCotto: {
        n: "Artichokes & Ham",
        d: "Mozzarella, artichokes, cooked ham",
      },
      tonnoPeperoni: {
        n: "Tuna & Peppers",
        d: "Mozzarella, tuna, peppers",
      },

      // ---- Top Pizzas ----
      topMortadella: {
        n: "Mortadella",
        d: "Radicchio, rocket, mortadella, stracciatella, pistachio pesto",
      },
      topCiauscolo: {
        n: "Ciauscolo",
        d: "Radicchio, rocket, ciauscolo, buffalo mozzarella",
      },
      topSalmone: {
        n: "Salmon",
        d: "Radicchio, rocket, stracciatella, salmon, balsamic vinegar",
      },
      topCrudo: {
        n: "Prosciutto Crudo",
        d: "Radicchio, rocket, buffalo mozzarella, prosciutto crudo",
      },
      topPomodorini: {
        n: "Cherry Tomatoes",
        d: "Red & yellow cherry tomatoes, semi-dry, rocket, stracciatella, pistachio pesto",
      },
    },
  },
};

export const menuData = [
  {
    id: "rosse",
    items: [
      { key: "marinara", price: "1,50", allergens: [1] },
      { key: "marinaraFarcita", price: "1,90", allergens: [1, 4] },
      { key: "mediterranea", price: "2,00", allergens: [1, 7] },
      { key: "margherita", price: "1,80", allergens: [1, 7] },
      { key: "salamePiccante", price: "2,00", allergens: [1, 7] },
      { key: "capricciosa", price: "2,00", allergens: [1, 7] },
      { key: "salsicciaPatate", price: "2,00", allergens: [1, 7] },
      { key: "mais", price: "2,00", allergens: [1, 7] },
      { key: "wurstel", price: "2,00", allergens: [1, 6, 7, 10] },
      { key: "amatriciana", price: "2,00", allergens: [1, 7] },
      { key: "funghi", price: "2,00", allergens: [1, 7] },
      { key: "carciofi", price: "2,00", allergens: [1, 7] },
      { key: "patatePancetta", price: "2,00", allergens: [1, 7] },
      { key: "quattroFormaggi", price: "2,00", allergens: [1, 7] },
    ],
  },
  {
    id: "bianche",
    items: [
      { key: "rosmarino", price: "1,20", allergens: [1] },
      { key: "farcitaSenzaMozzarella", price: "1,90", allergens: [1, 4] },
      { key: "cipolla", price: "1,50", allergens: [1] },
      { key: "semi", price: "1,50", allergens: [1, 11] },
      { key: "boscaiola", price: "2,00", allergens: [1, 7] },
      { key: "speckProvola", price: "2,00", allergens: [1, 7] },
      { key: "salsicciaCipollaCaramellata", price: "2,00", allergens: [1, 7] },
      { key: "patatePancettaB", price: "2,00", allergens: [1, 7] },
      { key: "patateSalsiccia", price: "2,00", allergens: [1, 7] },
      { key: "patateProvola", price: "2,00", allergens: [1, 7] },
      { key: "quattroFormaggiB", price: "2,00", allergens: [1, 7] },
      { key: "salsicciaFriarielli", price: "2,00", allergens: [1, 7] },
      { key: "friarielliPomodoriSecchi", price: "2,00", allergens: [1, 7] },
      { key: "aliciFriarielli", price: "2,00", allergens: [1, 4, 7] },
      { key: "norcina", price: "2,00", allergens: [1, 7] },
      { key: "carciofiCotto", price: "2,00", allergens: [1, 7] },
      { key: "tonnoPeperoni", price: "2,00", allergens: [1, 4, 7] },
    ],
  },
  {
    id: "top",
    items: [
      { key: "topMortadella", price: "3,50", allergens: [1, 7, 8] },
      { key: "topCiauscolo", price: "3,50", allergens: [1, 7] },
      { key: "topSalmone", price: "3,50", allergens: [1, 4, 7] },
      { key: "topCrudo", price: "3,50", allergens: [1, 7] },
      { key: "topPomodorini", price: "3,50", allergens: [1, 7, 8] },
    ],
  },
];

// EU Regulation 1169/2011 — 14 mandatory allergens
export const allergenList = [
  { id: 1, it: "Glutine", en: "Gluten", full_it: "Cereali contenenti glutine e prodotti derivati (grano, segale, orzo, avena, farro, kamut)", full_en: "Cereals containing gluten and derivatives (wheat, rye, barley, oats, spelt, kamut)" },
  { id: 2, it: "Crostacei", en: "Crustaceans", full_it: "Crostacei e prodotti a base di crostacei", full_en: "Crustaceans and products thereof" },
  { id: 3, it: "Uova", en: "Eggs", full_it: "Uova e prodotti a base di uova", full_en: "Eggs and products thereof" },
  { id: 4, it: "Pesce", en: "Fish", full_it: "Pesce e prodotti a base di pesce", full_en: "Fish and products thereof" },
  { id: 5, it: "Arachidi", en: "Peanuts", full_it: "Arachidi e prodotti a base di arachidi", full_en: "Peanuts and products thereof" },
  { id: 6, it: "Soia", en: "Soy", full_it: "Soia e prodotti a base di soia", full_en: "Soybeans and products thereof" },
  { id: 7, it: "Latte", en: "Milk", full_it: "Latte e prodotti a base di latte (incluso lattosio)", full_en: "Milk and products thereof (including lactose)" },
  { id: 8, it: "Frutta a guscio", en: "Tree nuts", full_it: "Frutta a guscio (mandorle, nocciole, noci, noci di anacardi, pistacchi)", full_en: "Tree nuts (almonds, hazelnuts, walnuts, cashews, pistachios)" },
  { id: 9, it: "Sedano", en: "Celery", full_it: "Sedano e prodotti a base di sedano", full_en: "Celery and products thereof" },
  { id: 10, it: "Senape", en: "Mustard", full_it: "Senape e prodotti a base di senape", full_en: "Mustard and products thereof" },
  { id: 11, it: "Sesamo", en: "Sesame", full_it: "Semi di sesamo e prodotti a base di semi di sesamo", full_en: "Sesame seeds and products thereof" },
  { id: 12, it: "Solfiti", en: "Sulphites", full_it: "Anidride solforosa e solfiti in concentrazioni superiori a 10 mg/kg o 10 mg/l espressi come SO₂", full_en: "Sulphur dioxide and sulphites (>10 mg/kg or mg/l expressed as SO₂)" },
  { id: 13, it: "Lupini", en: "Lupin", full_it: "Lupini e prodotti a base di lupini", full_en: "Lupin and products thereof" },
  { id: 14, it: "Molluschi", en: "Molluscs", full_it: "Molluschi e prodotti a base di molluschi", full_en: "Molluscs and products thereof" },
];

export const galleryImages = [
  {
    url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_chalk-pizza/artifacts/eecce6af00cabb6b_WhatsApp%20Image%202026-11-02%20at%2019.29.01%20%281%29.webp",
    alt: "Cookies artigianali con gocce di cioccolato",
  },
  {
    url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_chalk-pizza/artifacts/95b0cffe97319e0a_WhatsApp%20Image%202026-11-02%20at%2019.29.03%20%283%29.webp",
    alt: "Pizza in teglia con patate, salsiccia e prosciutto crudo croccante",
  },
  {
    url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_chalk-pizza/artifacts/494d80e676572085_WhatsApp%20Image%202026-11-02%20at%2019.29.03%20%282%29.webp",
    alt: "Pizza bianca con prosciutto crudo in dettaglio",
  },
  {
    url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_chalk-pizza/artifacts/30b4b59785bd3571_WhatsApp%20Image%202026-11-02%20at%2019.29.03%20%281%29.webp",
    alt: "Girelle alla cannella glassate appena sfornate",
  },
  {
    url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_chalk-pizza/artifacts/c05051044ece21d3_WhatsApp%20Image%202026-11-02%20at%2019.29.01.webp",
    alt: "Krapfen artigianali con zucchero a velo",
  },
];
